import React from 'react';
import { Section } from '../Section';
import { FadeUp } from '../FadeUp';
import { HERO_IMAGE, HERO_IMAGE_HEIGHT, HERO_IMAGE_WIDTH } from '../../data/images';
export function Hero() {
  return <Section className="pt-10 md:pt-14" data-id="element-144" data-mp="cvbgvoaxfjr1">
      <FadeUp className="flex flex-col items-center text-center" data-id="element-145" data-mp="cu9tqlgmz6sy">
        <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-146" data-mp="hv7ixi02d13y">
          Happy Parenting
        </p>

        <h1 className="mt-6 text-[30px] font-extrabold md:text-[46px]" data-id="element-147" data-mp="mtitxw23hhnr">
          Turn <em className="italic text-pain" data-id="element-148" data-mp="qukk7ne1ajdl">yelling and meltdowns</em> into{' '}
          <span className="text-gain" data-id="element-149" data-mp="vlu7wig0vcmu">calm routines</span> with this{' '}
          <span className="underline decoration-2 underline-offset-[6px]" data-id="element-150" data-mp="vootweeop5id">visual method</span>, in
          less than 24 hours.
        </h1>

        <img src={HERO_IMAGE} alt="The Positive Parenting Mega Kit box filled with printable routine charts" width={HERO_IMAGE_WIDTH} height={HERO_IMAGE_HEIGHT} loading="eager" decoding="async" fetchPriority="high" className="mt-8 block h-auto w-full max-w-[420px]" style={{
        aspectRatio: `${HERO_IMAGE_WIDTH} / ${HERO_IMAGE_HEIGHT}`,
        filter: 'drop-shadow(0 22px 26px rgba(20,17,15,0.18))'
      }} data-id="element-151" data-mp="15lbed233lujv" />

        <p className="mt-8 text-[13px] text-ink/55" data-id="element-152" data-mp="3rv0bo8f168lr">
          <span className="text-star" data-id="element-153" data-mp="setxchl966yt">★★★★★</span>&nbsp;&nbsp;Trusted by thousands of families
        </p>
      </FadeUp>
    </Section>;
}